import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';

export const VideoContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        .plyr {
            border-radius: ${theme.tggSpacing(rem(1.6), 4)};

            .plyr__control--overlaid {
                background: ${theme.isRebranding(theme.palette.primary.main, theme.palette.tgg.surface.action.main)};
                :hover {
                    background: ${theme.isRebranding(theme.palette.primary.main, theme.palette.tgg.surface.action.hover)};
                }
            }

            .plyr__controls__item input {
                color: ${theme.palette.primary.main};
            }

            .plyr__poster {
                background-size: cover;
            }
        }
    `}
`;
export const StyledVideo = styled('video')`
    width: 100%;
`;

export const StyledVideoDescription = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        justify-content: space-between;
        margin: ${theme.tggSpacing([rem(1.5), 0], [3.75, 0])};

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([0, rem(4)], [0, 10])};
            margin: ${theme.tggSpacing([rem(2), 0, rem(4)], [5, 0, 10])};
        }
    `}
`;

export const StyledTime = styled('span')`
    ${({ theme }: { theme: Theme }) => `
        margin-left: ${theme.tggSpacing(rem(0.5), 1.25)};

        ${theme.breakpoints.up('desktop')} {
            margin-left: ${theme.tggSpacing(rem(1), 2.5)};
        }
    `}
`;

export const StyledVideoTime = styled('div')`
    display: flex;
    align-items: center;
`;

export const StyledVideoTitle = styled(Heading)`
    text-transform: lowercase;
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmallBold};
`;
